import { useMemo } from 'react';

import { useIntl } from 'react-intl';

import { ROUTE_STATION_SERVICES_FILTERS } from '../constants';

export const useFilters = () => {
  const { formatMessage } = useIntl();

  const filters = useMemo(() => ([{
    key: ROUTE_STATION_SERVICES_FILTERS.all,
    value: formatMessage({ id: 'all' })
  }, {
    key: ROUTE_STATION_SERVICES_FILTERS.top5ByCountry,
    value: formatMessage({ id: 'top5ByCountry' })
  }, {
    key: ROUTE_STATION_SERVICES_FILTERS.topPriceEvery100km,
    value: formatMessage({ id: 'topPriceEvery100km' })
  }]), [formatMessage]);

  return filters;
};
